import React, { useCallback, useEffect, useState } from 'react';
import {
  View,
  Text,
  FlatList,
  ScrollView,
} from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { checkOut, fetchBillDetailsWithRetry, guestBillDetails, guestHistory, sendGuestMail } from '../../Redux/Actions/viewBillAction';
import { useTranslation } from 'react-i18next';
import { useCssStyle } from '../../customHook/getCssStyle';
import HeaderWithBack from '../../components/Header/headerWithBack';
import { ImageComp } from '../../components/Image/Image';
import CustomPressable from '../../components/customPressable/customPressable';
import { calculateTimeDifference, generateToken, getCleanUrl } from '../../utils/Helper';
import { getDataLoadingScreen } from '../../js/getDataLoadingScreen';
import CustomFlatList from '../../components/customFlatList';
import InfoPopupModal from '../../components/infoPopupModal';
import { setGoHome, setInitAppLogout, setShowLoginModal } from '../../Redux/Reducers/appConfigReducer';
import { formatDate } from '../../js/formatDate';
import FetchingDataScreen from '../../components/fetchingDataScreen';
import { useFocusEffect } from '@react-navigation/native';
import { sendAnalytics } from '../../Redux/Actions/analyticsAction';
import { CHECK_OUT_FAILED, CHECK_OUT_SUCCESS, CLICKED, EXIT, MY_BILL_CATEGORY } from '../../config/Constant';


const MyBill = ({ navigation }) => {

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const getStyles = useCssStyle();

  const [widgetLaunchTime, setWidgetLaunchTime] = useState(() => new Date());
  const [myBillSessionToken, setmyBillSessionToken] = useState(() => generateToken("mybill_"));
  const [modalState, setModalState] = useState({
    isInfoModalVisible: false,
    checkoutStatus: '',
    title: t('viewBill.checkout'),
    subTitle: t('viewBill.are_you_sure'),
    onClose: ()=>{},
    onContinue: ()=>{}
  })

  const [loadingState, setLoadingState] = useState({
    loading: true,
    loaderMessage: ''
  })


  const { currencyDetails } = useSelector(state => state.deviceConfigSlice);
  const currencyCode = currencyDetails.code;

  const { isLoggedIn, loggedInRoomNumber } = useSelector((state) => state.appConfigSlice);
  const { guestBillDetailsData, error } = useSelector(
    state => state.guestBillDetailsSlice,
  );

  const { currentGuestDetails } = useSelector(
    state => state.guestDetailsSlice,
  );

  const { currentWidget, extraConfigParam } = useSelector(
    state => state.deviceConfigSlice,
  );
  const dateFormat = extraConfigParam?.DATE_FORMAT;


  let reservationNumber = currentGuestDetails?.reservationNumber
  let locationId = currentGuestDetails?.location
  let arrival = currentGuestDetails?.checkInDate
  let checkout = currentGuestDetails?.plannedCheckOutDate
  let balanceAmount = guestBillDetailsData?.payload?.billTotal?.balanceAmount
  let billItems = guestBillDetailsData?.payload?.rawBill?.billItems
  let billTotal = guestBillDetailsData?.payload?.billTotalStr

  let expressCheckoutIntervalTime = extraConfigParam?.EXPRESS_CHECKOUT_TIME_INTERVALS
  // let expressCheckoutIntervalTime = ''

  let guestBillIntervalTime = expressCheckoutIntervalTime?.split(",")[2]

  const fetchData = async () => {
    setLoadingState(prev => ({
      ...prev,
      loading: true
    }))
    try {
      const {status, response} = await dispatch(guestHistory(reservationNumber, locationId, guestBillIntervalTime));
      if(!status){
        setModalState(prev => ({
          ...prev,
          isInfoModalVisible: true,
          checkoutStatus: 'retry',
          title: null,
          subTitle: response,
          onClose: handleGoBack,
          onContinue: retryBillDetails
        }))
      }
    } catch (error) {
      // setShowTryAgainModal(true);
    } finally {
      setLoadingState(prev => ({
        ...prev,
        loading: false
      }))
    }
  };

  const retryBillDetails = async () => {
    setLoadingState(prev => ({
      ...prev,
      loading: true
    }))
    try{
      const response = await dispatch(fetchBillDetailsWithRetry(reservationNumber, locationId));
      
    }catch (error) {
      setModalState(prev => ({
        ...prev,
        isInfoModalVisible: true,
        checkoutStatus: 'retry',
        title: null,
        subTitle: error,
        onClose: handleGoBack,
        onContinue: retryBillDetails
      }))
    }finally {
      setLoadingState(prev => ({
        ...prev,
        loading: false
      }))
    }
  }


  useFocusEffect(useCallback(() => {
    dispatch(sendAnalytics(MY_BILL_CATEGORY, CLICKED, { element: "widget", widgetSessionId: myBillSessionToken }))

    return () => {
      const widgetCloseTime = new Date;
      const widgetCloseDuration = calculateTimeDifference(widgetLaunchTime, widgetCloseTime, 'second');
      dispatch(sendAnalytics(MY_BILL_CATEGORY, EXIT, { element: "widget", "duration": widgetCloseDuration, widgetSessionId: myBillSessionToken }))
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []))

  const handleTryAgain = () => {
    // setShowTryAgainModal(false);
    fetchData();
  };

  const handleCheckoutPress = async () => {
    await dispatch(sendGuestMail(currentGuestDetails?.guestProfile?.email, locationId))
    setModalState(prev => ({
      ...prev,
      isInfoModalVisible: true
    }))
  };

  const onSuccess = async (msg) => {
    try{
      const response = await dispatch(guestBillDetails(reservationNumber, locationId));
      if(response?.payload?.XC?.Status == "SUCCESS"){
        setModalState(prev => ({
          ...prev,
          checkoutStatus: 'success',
          onClose: null,
          onContinue: onSuccessLogout
        }))
        
        dispatch(sendAnalytics(MY_BILL_CATEGORY, "CHECKOUT - SUCCESS", {element: "widget", widgetSessionId: myBillSessionToken }))

      } else if(response?.payload?.XC?.Status == "FAILED"){
        onFailure(response?.payload?.XC?.Message);
      } else {
        setModalState(prev => ({
          ...prev,
          checkoutStatus: 'retry',
          title: t('viewBill.checkoutFailed'),
          subTitle: t('viewBill.checkoutFailedMsg'),
          onClose: handleGoBack,
          onContinue: () => {handleInfoModalClose(); fetchData()}
        }))
        dispatch(sendAnalytics(MY_BILL_CATEGORY, "CHECKOUT - FAILED", { element: "widget", widgetSessionId: myBillSessionToken, "errorMessage": response?.header?.status?.msg }))
      }
      setLoadingState({
        loading: false,
        loaderMessage: null
      })
      
      
    } catch (err){
      console.log("Guest History: ", err)
      dispatch(sendAnalytics(MY_BILL_CATEGORY, "CHECKOUT - FAILED", { element: "widget", widgetSessionId: myBillSessionToken, "errorMessage": err?.message }))
    }
  }
  const onFailure = (msg) => {
    let errMessage = msg || t('viewBill.checkoutFailedMsg')
    setModalState(prev => ({
      ...prev,
      checkoutStatus: 'retry',
      title: t('viewBill.checkoutFailed'),
      subTitle: errMessage || t('viewBill.checkoutFailedMsg'),
      onClose: handleGoBack,
      onContinue: () => {handleInfoModalClose(); fetchData()}
    }))
    setLoadingState({
      loading: false,
      loaderMessage: null
    })

    dispatch(sendAnalytics(MY_BILL_CATEGORY, "CHECKOUT - FAILED", { element: "widget", widgetSessionId: myBillSessionToken, "errorMessage": errMessage }))
  }

  const handleContinue = async () => {
    setLoadingState({
      loading: true,
      loaderMessage: t('viewBill.checkingOut')
    })
    try {
      await dispatch(checkOut(currentGuestDetails, billTotal, onSuccess, onFailure));

    } catch (error) {
      setModalState(prev => ({
        ...prev,
        isInfoModalVisible: false
      }))
      dispatch(sendAnalytics(MY_BILL_CATEGORY, "CHECKOUT - FAILED", { element: "widget", widgetSessionId: myBillSessionToken, "errorMessage": error }))
    } finally {
      
    }
  };

  const handleGoBack = () => {
    setModalState(prev => ({
      ...prev,
      isInfoModalVisible: false
    }))
    if(navigation.canGoBack()){
      navigation.goBack();
    }
  }

  const onSuccessLogout = () => {
    dispatch(setInitAppLogout(true));
  }
  

  const handleInfoModalClose = () => {
    setModalState(prev => ({
      ...prev,
      isInfoModalVisible: false,
      checkoutStatus: undefined,
      title: t('viewBill.checkout'),
      subTitle: t('viewBill.are_you_sure'),
      onClose: handleInfoModalClose,
      onContinue: handleContinue
    }))
  };

  // useEffect(() => {
  //   if (error) {

  //     setShowTryAgainModal(true);
  //   }
  // }, [error]);

  const handleCloseModal = () => {
    // setShowTryAgainModal(false);
    dispatch(setGoHome(true));
  };

  useEffect(() => {
    if (!isLoggedIn) {
      dispatch(setShowLoginModal(true))
      dispatch(setGoHome(true));
      return;
    }
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(()=>{
    setModalState({
      isInfoModalVisible: false,
      checkoutStatus: '',
      title: t('viewBill.checkout'),
      subTitle: t('viewBill.are_you_sure'),
      onClose: handleInfoModalClose,
      onContinue: handleContinue
    })
    if(!expressCheckoutIntervalTime){
      setLoadingState(prev => ({
        ...prev,
        loading: false
      }))
      setModalState(prev => ({
        ...prev,
        isInfoModalVisible: true,
        checkoutStatus: 'error',
        title: t("viewBill.express_checkout_interval_time_err_title"),
        subTitle: t("viewBill.express_checkout_interval_time_err"),
        onClose: null,
        onContinue: handleGoBack
      }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[expressCheckoutIntervalTime, t])

  return (
    <View id='widgetRootContainer' style={getStyles(['widgetRootContainer'])}>
      <HeaderWithBack navigation={navigation} />
      {loadingState.loading &&  <FetchingDataScreen loaderMessage={loadingState.loaderMessage}/>}

        <ScrollView id='widgetmainContainer' contentContainerStyle={getStyles(['widgetmainContainer'])} showsVerticalScrollIndicator={false} >
          {isLoggedIn && <CustomFlatList
            viewPortHeight={true}
            showsVerticalScrollIndicator={false}
            ListHeaderComponent={
              <View>
                <ImageComp  id='widgetmainContainerHeaderImg ViewBillWidgetHeaderImg' source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} style={getStyles(['widgetmainContainerHeaderImg', 'ViewBillWidgetHeaderImg'])} />
                  <View id='billContainer' style={getStyles(['billContainer'])}>
                    <Text id='widgetmainContainerHeaderTitle billHeaderTitle' style={getStyles(["widgetmainContainerHeaderTitle", 'billHeaderTitle'])}>{t('viewBill.heading')}</Text>
                    <Text style={getStyles(["billHeaderSubTitle"])}>{t('viewBill.sub_heading')}</Text>

                    <Text id='total' style={getStyles(['total'])}>{t('viewBill.total')}</Text>
                    <Text id='amount' style={getStyles(['amount'])}>{currencyCode} {balanceAmount ? balanceAmount : 0}</Text>

                    <View id='detailsContainer dateContainer' style={getStyles(['detailsContainer', 'dateContainer'])}>
                      <View style={getStyles(["detailsItemContainer"])} id='detailsItemContainer'>
                        <Text id='arrivalBillText' style={getStyles(['arrivalBillText'])}>{formatDate(arrival, dateFormat)}</Text>
                        <Text id='dateBillText' style={getStyles(['dateBillText'])}>{formatDate(arrival, "h:mm A")}</Text>
                      </View>
                      <View style={getStyles(["detailsItemContainer"])} id='detailsItemContainer'>
                        <Text id='arrivalBillText' style={getStyles(['arrivalBillText'])}>
                          {(() => {
                            const start = new Date(arrival);
                            const end = new Date(checkout);
                            const diffTime = end - start;
                            const nights = Math.max(Math.floor(diffTime / (1000 * 60 * 60 * 24)), 0);
                            return `${nights} Night${nights !== 1 ? 's' : ''}`;
                          })()}
                          </Text>
                      </View>
                      <View style={getStyles(["detailsItemContainer"])} id='detailsItemContainer'>
                        <Text id='arrivalBillText' style={getStyles(['arrivalBillText'])}>{formatDate(checkout, dateFormat)}</Text>
                        <Text id='dateBillText' style={getStyles(['dateBillText'])}>{formatDate(checkout, "h:mm A")}</Text>
                      </View>
                    </View>

                    <View id='historyContainer' style={getStyles(['historyContainer'])}>
                      <Text id='purcharseBillText' style={getStyles(['purcharseBillText'])}>{t('viewBill.purchase_history')}</Text>
                      <Text id='reviewBill' style={getStyles(['reviewBill'])}>{t('viewBill.review_bill')}</Text>
                    </View>
                  </View>
              </View>
            }
            data={billItems}
            keyExtractor={(item, index) => index.toString()}
            renderItem={({ item }) => (
              <View id='list_itemContainer viewBill_Item_textContainer' style={getStyles(['list_itemContainer', 'viewBill_Item_textContainer'])}>
                <View id='list_itemContainer_textContainer ViewBill_itemContainer_textContainer_title' style={getStyles(['list_itemContainer_textContainer', 'ViewBill_itemContainer_textContainer_title'])}>
                  {item?.itemDesc && <Text id='list_itemContainer_textContainer_title ViewBill_itemContainer_textContainer_title' style={getStyles(['list_itemContainer_textContainer_title', 'ViewBill_itemContainer_textContainer_title'])}>{item?.itemDesc}</Text>}
                </View>

                <View id='list_itemContainer_arrow ViewBillWidgetChildContainer_itemContainer_arrow' style={getStyles(['list_itemContainer_arrow', 'ViewBillWidgetChildContainer_itemContainer_arrow'])}>
                  {item?.itemAmount && <Text id='list_itemContainer_textContainer_subtitle ViewBill_itemContainer_textContainer_subtitle' style={getStyles(['list_itemContainer_textContainer_subtitle', 'ViewBill_itemContainer_textContainer_subtitle'])} numberOfLines={2} ellipsizeMode="tail">{currencyCode} {item?.itemAmount}</Text>}

                </View>
              </View>

            )}
            ListEmptyComponent={ expressCheckoutIntervalTime &&
              <View id='list_itemContainer viewBill_Item_textContainer' style={getStyles(['list_itemContainer', 'viewBill_Item_textContainer'])}>
                <View id='list_itemContainer_textContainer ViewBill_itemContainer_textContainer_noHistory_container' style={getStyles(['list_itemContainer_textContainer', 'ViewBill_itemContainer_textContainer_noHistory_container'])}>
                <Text id='list_itemContainer_textContainer_noHistory ViewBill_itemContainer_textContainer_noHistory' style={getStyles(['list_itemContainer_textContainer_noHistory', 'ViewBill_itemContainer_textContainer_noHistory'])}>
                  {t("viewBill.no_history_present")}
                </Text>
                </View>
              </View>
            }
            // ListFooterComponent={ billItems &&
            //   <View id='ViewBillTotalContainer' style={getStyles(['ViewBillTotalContainer'])}>
            //     <View id='totalContainer' style={getStyles(['totalContainer'])}>
            //       <Text id='viewBillTotalLabel' style={getStyles(['viewBillTotalLabel'])}>{t('viewBill.total')}:</Text>
            //       <Text id='viewBillAmount' style={getStyles(['viewBillAmount'])}>{currencyCode} {billTotal ? billTotal : 0}</Text>
            //     </View>
            //   </View>
            // }
          />}
        </ScrollView>

      <View id='billCheckoutBtnContainer' style={getStyles(['billCheckoutBtnContainer'])}>
        <CustomPressable id='primaryBtn' onPress={() => handleCheckoutPress()} style={getStyles(['primaryBtn'])} disabled={!expressCheckoutIntervalTime}>
          <Text id='primaryBtnTxt' style={getStyles(['primaryBtnTxt'])}>
            <Text id='buttonText' style={getStyles(['buttonText'])}>{t('viewBill.checkout')}</Text>

          </Text>
        </CustomPressable>
      </View>


      {modalState.isInfoModalVisible && !loadingState.loading && 
      <InfoPopupModal
        type={modalState.checkoutStatus}
        title={modalState.checkoutStatus != 'loading' ? modalState.title : null}
        subtitle={modalState.checkoutStatus !== 'loading' && modalState.checkoutStatus !== 'success' ?  modalState.subTitle : null}
        onClose={modalState.onClose}
        onContinue={modalState.onContinue}
        isVisible={modalState.isInfoModalVisible}
        primaryBtnLabel={modalState.checkoutStatus == 'error' ? t('viewBill.on_error_primray_button_title') : modalState.checkoutStatus == 'retry' ? t('viewBill.retry') : null}
      >
        {!modalState.checkoutStatus && <View id='viewBill_infoModalRowView' style={getStyles(['viewBill_infoModalRowView'])} >
          <View>
            <Text id='viewBill_infoModalSubheader' style={getStyles(['viewBill_infoModalSubheader'])}>{t('viewBill.total')}</Text>
            <Text id='viewBill_infoModalTitle' style={getStyles(['viewBill_infoModalTitle'])}>{currencyCode} {billTotal ? billTotal : 0}</Text>
          </View>
          <View >
            <Text id='viewBill_infoModalSubheader' style={getStyles(['viewBill_infoModalSubheader'])}>
              {t('viewBill.room')}
            </Text>
            <Text id='viewBill_infoModalTitle' style={getStyles(['viewBill_infoModalTitle'])}>
              {loggedInRoomNumber || 'N/A'}
            </Text>
          </View>
        </View>}

      </InfoPopupModal>}
    </View>
  );
};


export default MyBill;
